import findALocationBlock from "@grindex-areas/Location/Views/Blocks/FindALocationBlock/xyl.views.findALocationBlock";
import findNearestLocationBlock from "@grindex-areas/Location/Views/Blocks/NearestLocationBlock/xyl.views.NearestLocationBlock";
import personalizedBannerContentBlock from "@grindex-areas/Core/Views/Blocks/PersonalizedBannerContentBlock/xyl.views.PersonalizedBannerContentBlock";
import documentSearchBlock from "@grindex-areas/Search/Views/Blocks/DocumentSearchBlock/xyl.views.documentSearchBlock";
import shipmentTrackingSearchBlock from "@grindex-areas/Search/Views/Blocks/ShipmentTrackingSearchBlock/xyl.views.shipmentTrackingSearchBlock";
import blogArchive from "@grindex-areas/Blog/Views/Blocks/BlogArchive/xyl.views.blogArchive";
import { marketoForm } from "@grindex-areas/LeadGeneration/Views/Blocks/MarketoFormBlock/js/xyl.views.marketoForm";
import mostRecentBlock from "@grindex-areas/NewsEvents/Views/Blocks/MostRecentBlock/xyl.views.mostRecentBlock";
import flippableCard from "@grindex-areas/Core/Views/Blocks/FlippableCardBlock/xyl.views.flippable-card";
import redirectPopupBlock from "@grindex-areas/Core/Views/Blocks/RedirectPopupBlock/redirectPopupBlock";
import genericCardBlock from "@grindex-areas/Core/Views/Blocks/GenericCardBlock/xyl.views.genericCardBlock";
import freeTextBlock from "@grindex-areas/Core/Views/Blocks/FreeTextBlock/xyl.views.freeTextBlock";
import hotspotImage from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.hotspotImage";
import videothumbnailcarousel from "@grindex-areas/VideoLibrary/Views/Blocks/ThumbnailVideoCarouselBlock/xyl.views.videothumbnailcarousel";
import imageCarousel from "@grindex-areas/Core/Views/Blocks/CarouselThumbnailBlock/imageCarousel.js";
import iframeBlock from "@grindex-areas/Core/Views/Blocks/IframeBlock/iframeBlock.js";

const blocks = [
	findALocationBlock,
	personalizedBannerContentBlock,
	documentSearchBlock,
	shipmentTrackingSearchBlock,
	blogArchive,
	findNearestLocationBlock,
	mostRecentBlock,
	flippableCard,
	marketoForm,
	genericCardBlock,
	freeTextBlock,
	redirectPopupBlock,
	videothumbnailcarousel,
	hotspotImage,
	imageCarousel,
	iframeBlock,
];

export { blocks };
